import { render } from "./Preload.vue?vue&type=template&id=5891330b"
import script from "./Preload.vue?vue&type=script&lang=js"
export * from "./Preload.vue?vue&type=script&lang=js"

import "./Preload.vue?vue&type=style&index=0&id=5891330b&lang=css"

import exportComponent from "/home/runner/work/Lineage-2-Vue-JS-3-Frontend/Lineage-2-Vue-JS-3-Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__